import { render, staticRenderFns } from "./PTOEntries.vue?vue&type=template&id=54a10f39&scoped=true&"
import script from "./PTOEntries.vue?vue&type=script&lang=js&"
export * from "./PTOEntries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a10f39",
  null
  
)

export default component.exports